import { useState, useCallback } from 'react';
import { useSuccessReactor, useErrorReactor } from '@livefree/reactive';
import { Alert, Button } from '@heroui/react';
import { useNavigate } from 'react-router';
import { useRecovery } from '@/features/login/forgot';
import { PasswordForm } from '@/shared/components';
import { RoutePaths } from '@/routing/RoutePaths';
import { reactive } from '@/core/reactive/reactive';

export const Reset = reactive.component(
  ({ services, monitors }) => {
    const [message, setMessage] = useState('');
    const [resetSuccess, setResetSuccess] = useState(false);
    const recovery = useRecovery();
    const navigate = useNavigate();

    useSuccessReactor(services.recovery.resetPassword, payload => {
      const { success, error } = payload;
      if (success) {
        recovery.clear();
        setResetSuccess(true);
      } else {
        setMessage(error);
      }
    });

    useErrorReactor(services.recovery.resetPassword, payload => {
      setMessage(payload);
    });

    const handleReset = useCallback(
      password => {
        if (recovery.username && recovery.code && password) {
          services.recovery.resetPassword(recovery.username, recovery.code, password);
        }
      },
      [services, recovery.username, recovery.code],
    );

    return resetSuccess ? (
      <div className="flex items-center justify-center w-full">
        <Alert
          color="primary"
          description="You can now login with your new password"
          endContent={
            <Button
              color="primary"
              size="sm"
              variant="flat"
              onPress={() => navigate(RoutePaths().login.login())}
            >
              Login
            </Button>
          }
          title="Password reset successfully"
          variant="faded"
        />
      </div>
    ) : (
      <PasswordForm
        label="Reset"
        errorMessage={message}
        onComplete={handleReset}
        isLoading={monitors.resetPassword.executing}
      />
    );
  },
  {
    name: 'Reset',
    monitors: services => [services.recovery.resetPassword],
  },
);
